import { ModuleType } from '@audacy-clients/client-services';
import { AdTargetingStatusParams } from '@audacy-clients/client-services/src/personalizationServices/types';
import { env } from './env';

const AD_SOURCE = '21674100491/NTL.AUDACY.WEB';
let TEST_BANNER_AD_SOURCE: string;
let TEST_SQUARE_AD_SOURCE: string;
const INLINE_AD = 'google-ad-manager___inline-1';
const RIGHT_RAIL_AD = 'google-ad-manager___right-rail-1';

if (env.API_ENV === 'STG') {
  TEST_BANNER_AD_SOURCE = '/6355419/Travel/Asia';
  TEST_SQUARE_AD_SOURCE = '/6355419/Travel/Europe';
}

export const setGoogleAdPreferences = (adTargeting: AdTargetingStatusParams): void => {
  if (!window.googletag) {
    return;
  }
  // default settings for OPT_IN for personalized Google Ads
  // https://developers.google.com/publisher-tag/reference#googletag.privacysettingsconfig
  let privacySettings = {
    restrictDataProcessing: false,
    childDirectedTreatment: false,
    underAgeOfConsent: false,
    limitedAds: false,
    nonPersonalizedAds: false,
  };

  // OPT_OUT and INELIGIBLE are to be treated the same by Google Ads
  if (adTargeting !== AdTargetingStatusParams.OPT_IN) {
    privacySettings = {
      ...privacySettings,
      restrictDataProcessing: true,
      limitedAds: true,
      nonPersonalizedAds: true,
    };
  }

  /// set Google Ads privacy settings
  window.googletag.cmd.push(() => {
    window.googletag.pubads().setPrivacySettings(privacySettings);
  });
};
